import { Alert } from "@mui/material";

export const SuccessAlert = ({ title }) => {
  return (
    <Alert severity="success" id="success-alert" sx={{ borderRadius: "0px" }}>
      {title}
    </Alert>
  );
};

export const ErrorAlert = ({ title }) => {
  return (
    <Alert severity="error" id="error-alert" sx={{ borderRadius: "0px" }} >
      {title}
    </Alert>
  );
};

export const DynamicAlert = ({ title, status, severity }) => {
  return (
    <Alert
      severity={severity ?? (status ? "success" : "error")}
      id="alert"
      sx={{
        borderRadius: "0px",
        position: "fixed",
        width: "100%",
        zIndex: 9999,
      }}
    >
      {title}
    </Alert>
  );
};
